import { createServiceStore } from 'common/store';
import { initialState } from './constants';
export var useCompanyAdditionalInfoStore = createServiceStore({
    initialValues: initialState,
});
